import React from 'react';
import './Compliance.css';

const Compliance = () => {
  return (
    <main>
      <section className="bg-primary-light mt-5 gold_pattern px-80 py-5">
        <div className="container mt-5">
          <div className="row justify-content-center mb-5 pb-5">
            <div className="col-lg-9">
              <div className="z-index-3 text-center">
                <h2 className="main-title mb-4 w-100">Regulatory &amp; Licensing</h2>
                <p className="fs-18 m-0" style={{ color: 'var(--cgo-text)', textAlign: 'center' }}>
                  ComTech Gold operates with full regulatory authorization and is committed to transparency in its legal structure,
                  platform classification, and compliance obligations. This page summarizes our regulatory status, jurisdiction of
                  operation, and the protections afforded to CGO token holders.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-secondary-light px-80 py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-11">
              <h3 className="h3 text-primary mt-4 mb-3">
                1. Legal Entity &amp; Regulatory Authorization
              </h3>
              <div className="table-responsive">
                <table className="table table-bordered align-middle cgo-table">
                  <thead>
                    <tr>
                      <th style={{ width: '35%', color: 'var(--cgo-table-head-fg)', backgroundColor: 'var(--cgo-table-head-bg)' }}>Field</th>
                      <th style={{ color: 'var(--cgo-table-head-fg)', backgroundColor: 'var(--cgo-table-head-bg)' }}>Detail</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="fw-semibold" style={{ color: 'var(--cgo-text)' }}>Legal Name</td>
                      <td style={{ color: 'var(--cgo-text)' }}>ComTech Gold FZCO</td>
                    </tr>
                    <tr>
                      <td className="fw-semibold" style={{ color: 'var(--cgo-text)' }}>Incorporation</td>
                      <td style={{ color: 'var(--cgo-text)' }}>Dubai Airport Free Zone (DAFZA), United Arab Emirates</td>
                    </tr>
                    <tr>
                      <td className="fw-semibold" style={{ color: 'var(--cgo-text)' }}>Regulatory Authority</td>
                      <td style={{ color: 'var(--cgo-text)' }}>Dubai Airport Free Zone Authority (DAFZA)</td>
                    </tr>
                    <tr>
                      <td className="fw-semibold" style={{ color: 'var(--cgo-text)' }}>Platform Classification</td>
                      <td style={{ color: 'var(--cgo-text)' }}>Digital gold and tokenized gold infrastructure platform</td>
                    </tr>
                    <tr>
                      <td className="fw-semibold" style={{ color: 'var(--cgo-text)' }}>Token Ticker</td>
                      <td style={{ color: 'var(--cgo-text)' }}>CGO (ComTech Gold Token)</td>
                    </tr>
                    <tr>
                      <td className="fw-semibold" style={{ color: 'var(--cgo-text)' }}>Blockchain</td>
                      <td style={{ color: 'var(--cgo-text)' }}>XDC Network (XinFin)</td>
                    </tr>
                    <tr>
                      <td className="fw-semibold" style={{ color: 'var(--cgo-text)' }}>Gold Standard</td>
                      <td style={{ color: 'var(--cgo-text)' }}>24 Karat, 999.9 and 999.5 fineness (LBMA standard)</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h3 className="h3 text-primary mt-5 mb-3">
                2. What ComTech Gold Is — and Is Not
              </h3>
              <p className="fs-18 mb-4" style={{ color: 'var(--cgo-text)' }}>
                Understanding our platform classification is essential for regulatory compliance.
              </p>
              <div className="row g-4">
                <div className="col-12 col-lg-6">
                  <div className="h-100 p-4 compliance-panel compliance-panel--positive border-radius shadow-sm">
                    <div className="fw-bold mb-3 fs-20" style={{ color: '#00AB7E' }}>✓ ComTech Gold IS</div>
                    <ul className="mb-0 fs-14" style={{ color: 'var(--cgo-text)' }}>
                      <li className="mb-2">A tokenized gold infrastructure platform</li>
                      <li className="mb-2">A physical gold custody and redemption service</li>
                      <li className="mb-2">A blockchain settlement infrastructure provider</li>
                      <li className="mb-2">Regulated by DAFZA as a Gold and precious metal trading.</li>
                    </ul>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="h-100 p-4 compliance-panel compliance-panel--negative border-radius shadow-sm">
                    <div className="fw-bold mb-3 fs-20" style={{ color: '#dc3545' }}>✗ ComTech Gold IS NOT</div>
                    <ul className="mb-0 fs-14" style={{ color: 'var(--cgo-text)' }}>
                      <li className="mb-2">A cryptocurrency exchange</li>
                      <li className="mb-2">A brokerage or trading platform</li>
                      <li className="mb-2">An investment advisory service</li>
                      <li className="mb-2">A financial institution or bank</li>
                      <li className="mb-2">Responsible for third-party exchange compliance</li>
                    </ul>
                  </div>
                </div>
              </div>

              <h3 className="h3 text-primary mt-5 mb-3">
                3. Restricted Jurisdictions
              </h3>
              <p className="fs-18 mb-4" style={{ color: 'var(--cgo-text)' }}>
                ComTech Gold tokens (CGO) may not be offered, sold, or transferred in jurisdictions where digital assets require regulatory
                authorization that has not been obtained, or where digital asset services are otherwise restricted.
              </p>
              <div className="compliance-panel compliance-callout p-4 mt-4 border-radius shadow-sm" style={{ backgroundColor: 'var(--cgo-surface-2)', borderLeft: '6px solid var(--cgo-accent)' }}>
                <p className="fs-18 mb-0 fw-semibold" style={{ color: 'var(--cgo-text)' }}>
                  CGO tokens are not currently available to residents or nationals of the United States, the United Kingdom, or
                  the European Union.
                </p>
              </div>
              <p className="fs-18 mt-4" style={{ color: 'var(--cgo-text)' }}>
                Additionally, users in the following jurisdictions should verify local regulatory requirements before transacting:
              </p>
              <ul className="fs-17" style={{ color: 'var(--cgo-text)' }}>
                <li className="mb-2">Singapore — subject to MAS licensing requirements for digital payment tokens</li>
                <li className="mb-2">UAE Retail — subject to VARA (Virtual Asset Regulatory Authority) requirements</li>
                <li className="mb-2">Any jurisdiction in which the purchase or holding of digital assets is prohibited by law</li>
              </ul>
              <p className="fs-18 mt-4" style={{ color: 'var(--cgo-text)' }}>
                Users are solely responsible for ensuring compliance with all applicable laws and regulations in their jurisdiction. The availability of CGO tokens on any third-party exchange does not constitute authorization for users in restricted jurisdictions to transact.
              </p>

              <h3 className="h3 text-primary mt-5 mb-3">
                4. AML &amp; KYC Compliance
              </h3>
              <div className="table-responsive mt-3">
                <table className="table table-bordered align-middle cgo-table">
                  <thead>
                    <tr>
                      <th style={{ width: '35%', color: 'var(--cgo-table-head-fg)', backgroundColor: 'var(--cgo-table-head-bg)' }}>Requirement</th>
                      <th style={{ color: 'var(--cgo-table-head-fg)', backgroundColor: 'var(--cgo-table-head-bg)' }}>Policy</th>
                    </tr>
                  </thead>
                  <tbody style={{ color: 'var(--cgo-text)' }} className="fs-17">
                    <tr>
                      <td className="fw-semibold">Account Opening</td>
                      <td>Identity verification (KYC) is mandatory for all users prior to account activation</td>
                    </tr>
                    <tr>
                      <td className="fw-semibold">Gold Redemption</td>
                      <td>Enhanced KYC is required for physical gold delivery requests</td>
                    </tr>
                    <tr>
                      <td className="fw-semibold">Institutional Onboarding</td>
                      <td>Corporate KYC including beneficial owner identification and corporate documentation required</td>
                    </tr>
                    <tr>
                      <td className="fw-semibold">AML Screening</td>
                      <td>All users are screened against international sanctions lists and PEP databases</td>
                    </tr>
                    <tr>
                      <td className="fw-semibold">Transaction Monitoring</td>
                      <td>Ongoing monitoring of transactions for suspicious activity indicators</td>
                    </tr>
                    <tr>
                      <td className="fw-semibold">Regulatory Reporting</td>
                      <td>ComTech Gold complies with applicable UAE financial reporting obligations</td>
                    </tr>
                    <tr>
                      <td className="fw-semibold">Data Retention</td>
                      <td>KYC and transaction records retained in accordance with UAE regulatory requirements</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h3 className="h3 text-primary mt-5 mb-3">
                5. Asset Ownership &amp; Bankruptcy Protection
              </h3>
              <p className="fs-18 mb-4" style={{ color: 'var(--cgo-text)' }}>
                A fundamental feature of CGO tokens is that the underlying physical gold is legally separated from ComTech Gold&apos;s
                corporate assets.
              </p>
              <div className="bg-primary-dark p-4 mt-4 border-radius gold_pattern">
                <p className="fs-18 mb-0 text-center italic" style={{ color: '#fff' }}>
                  &quot;CGO token holders are beneficial owners of allocated physical gold held in segregated vault accounts. The gold
                  backing CGO tokens does not form part of ComTech Gold&apos;s balance sheet and is not available to ComTech Gold&apos;s
                  general creditors in any insolvency event.&quot;
                </p>
              </div>
              <div className="mt-4 fs-18 mb-5" style={{ color: 'var(--cgo-text)' }}>
                <p className="mb-3">
                  <span className="fw-bold" style={{ color: 'var(--cgo-accent)' }}>Segregated Custody:</span> Physical gold is held in segregated accounts at
                  TransGuard Group vaults, an Emirates Group Company, in the UAE.
                </p>
                <p className="mb-3">
                  <span className="fw-bold" style={{ color: 'var(--cgo-accent)' }}>DMCC Tradeflow Warrants:</span> All gold movements in and out of custody are recorded by the DMCC Tradeflow Warrants.
                </p>
                <p className="mb-3">
                  <span className="fw-bold" style={{ color: 'var(--cgo-accent)' }}>Insolvency Protection:</span> In the unlikely event of ComTech Gold&apos;s insolvency,
                  the physical gold associated with your CGO tokens is protected from corporate creditors. Your holdings will be
                  transferred to your legal heir or redeemed per applicable procedures.
                </p>
                <p className="mb-0">
                  <span className="fw-bold" style={{ color: 'var(--cgo-accent)' }}>Insurance:</span> All gold stored with TransGuard is covered by a comprehensive
                  global insurance policy maintained by the custodian.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Compliance;
